import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Forum from 'flarum/common/models/Forum';

import Application from '../common/models/Application';
import ApplicationConfig from '../common/models/ApplicationConfig';
import ApplicationConfigDefault from '../common/models/ApplicationConfigDefault';
import ApplicationHistory from '../common/models/ApplicationHistory';
import ApplicationKey from '../common/models/ApplicationKey';
import ApplicationsPage from './components/ApplicationsPage';
import ApplicationStatusPage from './components/ApplicationStatusPage';
import ApplicationConfigsPage from './components/ApplicationConfigsPage';
import ApplicationConfigPage from './components/ApplicationConfigPage';
import CheatpanelPage from './components/CheatpanelPage';

export default [
    (new Extend.Store())
        .add('applications', Application)
        .add('application.configs', ApplicationConfig)
        .add('application.default_configs', ApplicationConfigDefault)
        .add('application.histories', ApplicationHistory)
        .add('application.keys', ApplicationKey),

    (new Extend.Routes())
        .add('applications', '/applications', ApplicationsPage)
        .add('application.status', '/applications/status', ApplicationStatusPage)
        .add('application.configs', '/applications/:application/configs', ApplicationConfigsPage)
        .add('application.configs.show', '/applications/:application/configs/:config', ApplicationConfigPage)
        .add('cheatpanel', '/cheatpanel', CheatpanelPage).add('cheatpanel.payload', '/cheatpanel/payload', null),

    (new Extend.Model(User))
        .attribute<boolean>('isSubscribed')
        .attribute<boolean>('isSuspended')
        .attribute<boolean>('canEditApplications')
        .hasMany<Application>('applications'),

    (new Extend.Model(Forum))
        .attribute<boolean>('canViewApplications')
        .attribute<boolean>('canEditApplications')
        .attribute<boolean>('canCreateApplicationKeys')
];
